import { Formatting } from '../../data/formatting';
import { DataStore } from '../../data/store';
import { TrendRow, TrendValue, TrendsInfo } from '../../design/charts';
import { DataColumn } from '../../types';

export function makeTrendsInfo(data: DataStore, grouping: string, columnNames: string[]): TrendsInfo | undefined {
  const dataColumns: DataColumn[] = [];
  columnNames.forEach(name => {
    const column = data.getDataColumns().find(col => col.name === name);
    if (column && column?.arrayLength !== null) {
      dataColumns.push(column);
    }
  });

  const dataSrc = data.getGroupedData([grouping])[0];
  if (!dataSrc || dataSrc.data.length === 0) {
    return;
  }
  const rows: TrendRow[] = [];
  dataColumns.forEach(column => {
    const values = dataSrc.data[0].values[column.name] as (number | null)[];
    let valuesList: TrendValue[] = values
      ? values.map(value => ({
          raw: value,
          formatted: Formatting.format(value, {
            dataType: column.dataType,
            formatHint: column.formatHint,
            currency: data.getCurrency(),
          }),
        }))
      : Array(column.arrayLength)
          .fill(null)
          .map(_ => ({
            raw: null,
            formatted: '-',
          }));

    rows.push({
      label: column.label,
      values: valuesList,
    });
  });

  return {
    rows,
    periods: dataSrc.timeFrame.periods.map(p => p.name),
  };
}
